import React from 'react'
import PropTypes from 'prop-types'

import CircledArrow from 'images/circled-arrow.svg'

const Heading = ({ text, withArrow }) => (
  <h1>
    {text}
    {withArrow && (
      <>
        {' '}
        <span className="circled-arrow-container">
          <CircledArrow className="circled-arrow-top" />
          <CircledArrow className="circled-arrow" />
          <CircledArrow className="circled-arrow-bottom" />
        </span>
      </>
    )}
  </h1>
)

Heading.propTypes = {
  text: PropTypes.string,
  withArrow: PropTypes.bool,
}

export default Heading
